var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-6769",
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.789,
    height: 100.499,
    viewBox: "0 0 105.789 100.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layer3",
    d: "M60.868,33.742V8H45V20.342Z",
    transform: "translate(30.815 -0.947)",
    fill: "#f27e7c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M48.789,4,10,37.5v67H34.684V69.236h28.21V104.5H87.578v-67.7Z",
    transform: "translate(4.105 -4)",
    fill: "#ffdea5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M2,46.316,54.894,4l52.894,42.316Z",
    transform: "translate(-2 -4)",
    fill: "#3f5275"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "opacity",
    d: "M54.894,4,16.105,35.031,2,46.316H16.105V104.5H40.789V69.236H54.894Z",
    transform: "translate(-2 -4)",
    fill: "#000064",
    opacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e9eabc0ff4f691365459c0ecd777769b.svg";
export { ForwardRef as ReactComponent };